// École Nid Douillet - Authentication Layout Component
// Layout for login and authentication pages

import React from 'react';
import { useTranslation } from 'react-i18next';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        {/* Logo and school name */}
        <div className="text-center">
          <div className="mx-auto h-16 w-16 rounded-xl bg-primary-600 flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-xl">ND</span>
          </div>
          <h1 className="mt-6 text-3xl font-bold text-neutral-900">
            {t('school.name')}
          </h1>
          <p className="mt-2 text-sm text-neutral-600">
            {t('school.description')}
          </p>
        </div>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-xl rounded-xl sm:px-10">
          {children}
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <p className="text-xs text-neutral-500">
          {t('school.address')} • {t('school.phone')}
        </p>
        <p className="mt-1 text-xs text-neutral-400">
          {t('school.motto')}
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;
